import ApiPublic from './clients/ApiPublic'

export default {
  getReports () {
    return ApiPublic.get('public/menu/')
  }
}
